import { render, staticRenderFns } from "./BaseContentIntro.vue?vue&type=template&id=63b0b4bd&"
import script from "./BaseContentIntro.vue?vue&type=script&lang=js&"
export * from "./BaseContentIntro.vue?vue&type=script&lang=js&"
import style0 from "./BaseContentIntro.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports